/**
 *
 * @param {Map<String, any>} parent
 */
const processParentOptionsRefs = (parent) => {
  const options = /** @type {OptionsProps} */ (parent.get("options"));
  const entries = options?.entries() || [];

  for (const [name, values] of entries) {
    const current = values.get("resolutions").get("current");

    if (
      name === "duration" &&
      (current.get("value") === 0 ||
        parent.get("is-action") ||
        parent.get("is-reference"))
    ) {
      current.set("value", 1e-12);
    }

    if (name === "easing") {
      parent.set(
        "has-spring",
        values.get("v_name") === "spring" || values.get("v_value") === "spring"
      );
    }

    if (name === "direction" && values.get("v_value") === "alternate") {
      parent.set("has-alternate", true);
    }

    parent.set(`o_${name}`, current.get("value"));
  }
};

export default processParentOptionsRefs;
